export const BAR_VERTICAL_OFFSET = 20;
export const BAR_HORIZONTAL_OFFSET = 4;
